module.exports = __webpack_public_path__ + "static/infocontpaq2-image-71d0d952b8e8734dbc40affd2fc65a1d.png";